import { SubscriptionServiceModule } from 'services/access/subscription/subscription.service';
import { TrialServiceModule, NOT_TRIAL } from 'components/trial/trial.service';
import { CalendlyModalModule } from './calendlyModal.component';

export const LaunchCalendlyModalModule = angular
    .module('app.components.launchCalendly', [
        CalendlyModalModule,
        SubscriptionServiceModule,
        TrialServiceModule
    ]).service('launchCalendlyModal', ($mdDialog, $q, subscriptionsService, trialService) => {
        function open(link) {
            return $mdDialog.show({
                parent: angular.element('body'),
                clickOutsideToClose: true,
                fullscreen: true,
                hasBackdrop: true,
                template: `
                <md-dialog
                    class="calendly-modal"
                    aria-label="Schedule a call dialog">
                        <calendly-modal link="'${link}'"></calendly-modal>
                </md-dialog>`
            });
        }

        function isProPlan(planId) {
            return [
                process.env.PROFESSIONAL_3M_3APPS_PLAN_ID,
                process.env.PROFESSIONAL_3M_79_PLAN_ID,
                process.env.PROFESSIONAL_3APPS_PLAN_ID,
                process.env.PROFESSIONAL_79_PLAN_ID,
                process.env.PRO_PLAN_ID,
                process.env.PROFESSIONAL_PLAN_ID
            ].includes(planId);
        }

        function getSupportUrl() {
            return $q.all([
                subscriptionsService.getPlan(),
                trialService.getTrialStatus()
            ]).then(([plan, trialStatus]) => {
                if (trialStatus !== NOT_TRIAL) {
                    return 'https://calendly.com/v2-ce-call-scheduling';
                }

                return isProPlan(plan.id) ?
                    'https://calendly.com/professional-plan-schedule-a-call' :
                    'https://calendly.com/v2-ce-call-scheduling';
            });
        }

        function openSupportScheduler() {
            return getSupportUrl().then(open);
        }
        function openCancellationScheduler() {
            return open('https://calendly.com/happiness-2/15min');
        }
        function openOnboardingScheduler() {
            return open('https://calendly.com/volusion-advisors-v2/call');
        }

        return {
            openOnboardingScheduler,
            openSupportScheduler,
            openCancellationScheduler
        };
    }).name;




// WEBPACK FOOTER //
// ./src/app/components/calendlyLauncher/calendlyLaunch.service.js